import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Courses() {
  return <section id="courses" className="py-32 bg-surface" data-id="element-65">
      <div className="container mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-66">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col" data-id="element-67">
          <h2 className="order-1 font-heading text-4xl md:text-5xl font-semibold tracking-tight text-ink mb-6" data-id="element-68">
            Стань майстром
          </h2>
          <div className="order-2 w-12 h-1 bg-ink rounded-full mb-8" data-id="element-69"></div>

          {/* Mobile Image */}
          <div className="order-3 md:hidden relative h-[400px] w-full mb-10 group" data-id="element-70">
            <div className="w-full h-full bg-white rounded-[2rem] border border-line shadow-xl flex items-center justify-center overflow-hidden" data-id="element-71">
              <div className="text-center" data-id="element-72">
                <div className="w-14 h-14 mx-auto mb-3 border border-line rounded-full flex items-center justify-center bg-surface" data-id="element-73">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-muted" data-id="element-74">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" data-id="element-75"></rect>
                    <circle cx="8.5" cy="8.5" r="1.5" data-id="element-76"></circle>
                    <polyline points="21 15 16 10 5 21" data-id="element-77"></polyline>
                  </svg>
                </div>
                <p className="text-xs text-muted font-medium tracking-widest uppercase" data-id="element-78">
                  Фото процесу
                </p>
              </div>
            </div>
          </div>

          <div className="order-4" data-id="element-79">
            <p className="text-muted font-normal text-lg leading-relaxed mb-10" data-id="element-80">
              Авторські курси для початківців та майстрів, які хочуть підвищити
              свою кваліфікацію. Навчання проходить у міні-групах, що гарантує
              індивідуальний підхід до кожного учня.
            </p>

            <ul className="space-y-5 mb-12" data-id="element-81">
              {['80% практичних занять на моделях', 'Надання всіх необхідних інструментів та матеріалів', 'Сертифікат після успішного завершення', 'Підтримка та консультації після курсу'].map((item, i) => <li key={i} className="flex items-start" data-id="element-82">
                  <div className="bg-white p-1 rounded-full border border-line mr-4 mt-0.5 shadow-sm" data-id="element-83">
                    <Check className="text-ink flex-shrink-0" size={14} strokeWidth={3} data-id="element-84" />
                  </div>
                  <span className="text-ink font-medium text-base" data-id="element-85">{item}</span>
                </li>)}
            </ul>

            <Link to="/courses" className="inline-block w-full sm:w-auto px-8 py-4 bg-ink text-white text-center text-sm font-medium tracking-wide rounded-full hover:bg-black transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-86">
              Детальніше про курси
            </Link>
          </div>
        </motion.div>

        {/* Desktop Image */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="hidden md:block relative h-[500px] lg:h-[600px] group" data-id="element-87">
          <div className="w-full h-full bg-white rounded-[2.5rem] border border-line shadow-2xl flex items-center justify-center overflow-hidden transition-transform duration-700 ease-out group-hover:scale-[1.02]" data-id="element-88">
            <div className="text-center" data-id="element-89">
              <div className="w-16 h-16 mx-auto mb-4 border border-line rounded-full flex items-center justify-center bg-surface" data-id="element-90">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-muted" data-id="element-91">
                  <rect x="3" y="3" width="18" height="18" rx="2" ry="2" data-id="element-92"></rect>
                  <circle cx="8.5" cy="8.5" r="1.5" data-id="element-93"></circle>
                  <polyline points="21 15 16 10 5 21" data-id="element-94"></polyline>
                </svg>
              </div>
              <p className="text-sm text-muted font-medium tracking-widest uppercase" data-id="element-95">
                Фото процесу навчання
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}